import type { TranslationTree } from '../../types';

export const contact: TranslationTree = {
  contact: {
    intro: {
      badge: 'Contact',
      title: 'Reach the ToolLife team',
      description: 'Fill in the form to open a pre-filled email in your mail client.',
      highlights: {
        question: {
          title: 'Ask a question',
          description: 'Describe what you need — we will read and reply by email.',
        },
        bug: {
          title: 'Report a bug',
          description: 'Specify the affected module and steps to reproduce.',
        },
        followUp: {
          title: 'Improvement suggestion',
          description: 'Share ideas to improve the app or request a new feature.',
        },
      },
    },
    form: {
      badge: 'Contact form',
      title: 'Send us a message',
      description:
        'Fill in the fields below — clicking send opens your mail client with the message ready to send.',
      contactInfo: {
        title: 'Direct address',
        copyCta: 'Copy address',
        copySuccess: 'Address copied!',
        copyError: 'Copy is not available on this device.',
      },
      fields: {
        subjectLabel: 'Subject',
        subjectPlaceholder: 'e.g. Scanner synchronization issue',
        categoryLabel: 'Request type',
        categoryPlaceholder: 'Select',
        messageLabel: 'Message',
        messagePlaceholder:
          'Describe your question or the bug you encountered, including reproduction steps if possible.',
      },
      categories: {
        bug: 'Bug or issue',
        question: 'How-to question',
        improvement: 'Improvement suggestion',
        other: 'Other',
        fallback: 'Request',
      },
      copy: {
        notAvailable: 'Copy is not available on this device.',
      },
      emailFallback: 'No address provided',
      mail: {
        subject: '{{category}} - {{subject}}',
        body: 'Request type: {{category}}\n---\nSender: {{author}}\n---\n{{message}}\n',
      },
      status: {
        successTitle: 'Your email client has been opened.',
        successDescription:
          'Review the content before sending and feel free to add screenshots if needed.',
        errorDefault: 'Unable to open your email client.',
        opening: 'Opening…',
      },
      actions: {
        openClient: 'Open my email client',
        reset: 'Reset form',
        back: 'Back',
      },
    },
  },
};
